module.exports = __webpack_public_path__ + "img/beer_id-26.44a06eda.png";